import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer>
      <p>&copy; 2026 Lo-Dis by Steampunk Circuits. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
